import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { RoomTypeGroup } from './RoomTypeGroup';
import { EmptyState } from './EmptyState';
import { StartCard } from './StartCard';
import { OfferListSkeleton } from './Skeletons';
const offerCount = (groups) => groups.reduce((total, group) => total + group.ratePlans.length, 0);
// Rendered by the Search route next to the view toggle (not inside the list)
// so the first result card and the quote rail card top-align.
export const SummaryLine = ({ groups }) => {
    const offers = offerCount(groups);
    const rooms = groups.length;
    return (_jsxs("p", { className: "text-sm font-medium text-light-midnight", children: [offers, " ", offers === 1 ? 'offer' : 'offers', " \u00B7 ", rooms, ' ', rooms === 1 ? 'room type' : 'room types'] }));
};
// Renders the result of a search: prompt, spinner, error, empty state, or the
// grouped offer list. Purely presentational — grouping happens upstream.
export const OfferList = ({ status, groups, errorMessage, property, onAddLine, expansion }) => {
    if (status === 'idle') {
        return _jsx(StartCard, {});
    }
    if (status === 'loading') {
        return _jsx(OfferListSkeleton, {});
    }
    if (status === 'error') {
        return (_jsx("div", { className: "rounded-2xl border border-error/40 bg-error/5 px-4 py-6 text-sm text-error", children: errorMessage ?? 'Something went wrong loading offers.' }));
    }
    if (groups.length === 0) {
        return _jsx(EmptyState, {});
    }
    return (_jsx("div", { className: "flex flex-col gap-4", children: groups.map(group => (_jsx(RoomTypeGroup, { group: group, property: property, onAddLine: onAddLine, isExpanded: expansion.isExpanded(group.roomTypeId), onToggle: () => expansion.toggle(group.roomTypeId) }, group.roomTypeId))) }));
};
